import { FC, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { EAdvancedSelectedTabs } from 'interfaces/bet-data';
import { EFreeBetsActions } from 'newelements/_Betslip/managers/FreeBetManager/actions';
import { FreeBetManagerSliceSingle } from 'newelements/_Betslip/managers/FreeBetManager/BetTypeBaseSlice/single';
import { fetchAdvancedMultipleFreeBets } from 'newelements/_Betslip/managers/FreeBetManager/utils/fetchFreeBetAmounts/advanced';
import { useEventbus } from 'newhooks/generic/useEventbus';
import { getAdvancedSelectedTab, getAllBetIds } from 'store/selectors/betslip';

export const FreeBetBetslipTypeSliceAdvanced: FC = () => {
  const selectedTab = useSelector(getAdvancedSelectedTab);
  const allBetsIds = useSelector(getAllBetIds);
  useEventbus({
    [EFreeBetsActions.GET_FREE_BETS]: fetchAdvancedMultipleFreeBets
  });

  useLayoutEffect(fetchAdvancedMultipleFreeBets, []);

  if (
    selectedTab === EAdvancedSelectedTabs.MULTIPLES ||
    allBetsIds.length === 1
  ) {
    return <FreeBetManagerSliceSingle getOnMount />;
  }

  return null;
};
